import React, { FC, useState } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Layout } from 'antd';
import {
    AdminHeader,
    UserLists,
    DesignLists,
    PrinterLists,
    AdminDashboard,
    Sider3D,
    AdminInbox,
} from '../../Components/AdminComponents';
// import OrdersList from '../../Components/AdminComponents/OrdersList';
import OrdersListNew from "../../Components/AdminComponents/OrdersListNew";
import PrinterDescription from '../../Components/AdminComponents/PrinterDescription';


const { Content } = Layout;

const StyledLayout = styled(Layout)`
    min-height: 100vh;
`
const ContentX = styled(Content)`
    margin: 2rem;
`

const Admin: FC = (props: any) => {
    const [collapsed, setCollapsed] = useState(false);
    const [activeKey, setActiveKey] = useState('/dashboard');
    const toggle = () => {
        setCollapsed(!collapsed);
    }
    return (
        <>
            <StyledLayout>
                <Sider3D collapsed={collapsed} activeKey={activeKey} />
                <Layout>
                    <AdminHeader collapsed={collapsed} toggle={toggle} />
                    <ContentX>
                        <Switch>
                            <Route exact path={`${props.match.path}/dashboard`} render={() => {
                                setActiveKey('/dashboard')
                                return <AdminDashboard />
                            }} />
                            <Route exact path={`${props.match.path}/users`} render={() => {
                                setActiveKey('/users')
                                return <UserLists />
                            }} />
                            <Route exact path={`${props.match.path}/designs`} render={() => {
                                setActiveKey('/designs')
                                return <DesignLists />
                            }} />
                            <Route exact path={`${props.match.path}/printers`} render={() => {
                                setActiveKey('/printers')
                                return <PrinterLists />
                            }}
                            />
                            <Route exact path={`${props.match.path}/printers/:id`} render={() => {
                                setActiveKey('/printers')
                                return <PrinterDescription />
                            }}
                            />
                            <Route exact path={`${props.match.path}/orders`} render={() => {
                                setActiveKey('/orders')
                                return <OrdersListNew />;
                            }} />
                            <Route exact path={`${props.match.path}/inbox`} render={() => {
                                setActiveKey('/inbox')
                                return <AdminInbox />;
                            }} />
                        </Switch>
                    </ContentX>
                </Layout>
            </StyledLayout>
        </>
    )
}

export default withRouter(Admin);